var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "paycools-kyc-page" }, [
    _c(
      "section",
      { staticClass: "kyc-content" },
      [
        _c(
          "header",
          { staticClass: "kyc-header" },
          [
            _c(
              "el-button",
              {
                staticStyle: { padding: "0" },
                attrs: { type: "text" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("requestBack")
                  },
                },
              },
              [
                _c("svg-icon", {
                  attrs: {
                    "icon-class": "back",
                    "class-name": "kyc-back-icon",
                  },
                }),
              ],
              1
            ),
            _c("h2", { staticClass: "kyc-title" }, [
              _vm._v(_vm._s(_vm.$t("kyc.title"))),
            ]),
          ],
          1
        ),
        _c(
          "el-form",
          {
            ref: "form",
            staticClass: "kyc-form",
            attrs: { model: _vm.form, rules: _vm.rules },
          },
          [
            _vm.rejectionItems && _vm.rejectionItems.length
              ? _c(
                  "div",
                  {
                    staticClass: "kyc-rejection-box",
                    staticStyle: { "margin-bottom": "16px" },
                  },
                  [
                    _c(
                      "el-alert",
                      {
                        attrs: {
                          type: "error",
                          title: _vm.$t("kyc.rejection_title"),
                          closable: false,
                          "show-icon": "",
                        },
                      },
                      _vm._l(_vm.rejectionItems, function (item, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "rejection-item" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(index + 1) +
                                ". " +
                                _vm._s(item) +
                                " "
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _c("div", { staticClass: "kyc-upload-grid" }, [
              _c(
                "div",
                { staticClass: "kyc-upload-card" },
                [
                  _c("div", { staticClass: "kyc-upload-title" }, [
                    _c("span", { staticStyle: { color: "#f56c6c" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v(
                      _vm._s(
                        _vm.$t("kyc.company_document_articles_of_association")
                      )
                    ),
                  ]),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item-no-style",
                      attrs: { prop: "aoa" },
                    },
                    [
                      _c("UpdateFile", {
                        ref: "aoa",
                        attrs: {
                          type: "aoa",
                          "file-list": _vm.fileList,
                          uploading: _vm.uploading,
                          "remove-files": _vm.removeFiles,
                          "uploading-progress": _vm.uploadingProgress,
                        },
                        on: {
                          changeFileList: _vm.changeFileList,
                          changeUploading: _vm.changeUploading,
                          changeUploadingProgress: _vm.changeUploadingProgress,
                          changeRemoveFiles: _vm.changeRemoveFiles,
                        },
                        model: {
                          value: _vm.form.aoa,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "aoa", $$v)
                          },
                          expression: "form.aoa",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "kyc-upload-card" },
                [
                  _c("div", { staticClass: "kyc-upload-title" }, [
                    _c("span", { staticStyle: { color: "#f56c6c" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v(
                      _vm._s(
                        _vm.$t("kyc.company_document_registration_certificate")
                      )
                    ),
                  ]),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item-no-style",
                      attrs: { prop: "sc" },
                    },
                    [
                      _c("UpdateFile", {
                        ref: "sc",
                        attrs: {
                          type: "sc",
                          "file-list": _vm.fileList,
                          uploading: _vm.uploading,
                          "remove-files": _vm.removeFiles,
                          "uploading-progress": _vm.uploadingProgress,
                        },
                        on: {
                          changeFileList: _vm.changeFileList,
                          changeUploading: _vm.changeUploading,
                          changeUploadingProgress: _vm.changeUploadingProgress,
                          changeRemoveFiles: _vm.changeRemoveFiles,
                        },
                        model: {
                          value: _vm.form.sc,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "sc", $$v)
                          },
                          expression: "form.sc",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "kyc-upload-card" },
                [
                  _c("div", { staticClass: "kyc-upload-title" }, [
                    _c("span", { staticStyle: { color: "#f56c6c" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v(
                      _vm._s(_vm.$t("kyc.company_document_tax_documents"))
                    ),
                  ]),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item-no-style",
                      attrs: { prop: "br" },
                    },
                    [
                      _c("UpdateFile", {
                        ref: "br",
                        attrs: {
                          type: "br",
                          "file-list": _vm.fileList,
                          uploading: _vm.uploading,
                          "remove-files": _vm.removeFiles,
                          "uploading-progress": _vm.uploadingProgress,
                        },
                        on: {
                          changeFileList: _vm.changeFileList,
                          changeUploading: _vm.changeUploading,
                          changeUploadingProgress: _vm.changeUploadingProgress,
                          changeRemoveFiles: _vm.changeRemoveFiles,
                        },
                        model: {
                          value: _vm.form.br,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "br", $$v)
                          },
                          expression: "form.br",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "kyc-upload-card" },
                [
                  _c("div", { staticClass: "kyc-upload-title" }, [
                    _c("span", { staticStyle: { color: "#f56c6c" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v(
                      _vm._s(_vm.$t("kyc.company_document_business_permit"))
                    ),
                  ]),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item-no-style",
                      attrs: { prop: "mp" },
                    },
                    [
                      _c("UpdateFile", {
                        ref: "mp",
                        attrs: {
                          type: "mp",
                          "file-list": _vm.fileList,
                          uploading: _vm.uploading,
                          "remove-files": _vm.removeFiles,
                          "uploading-progress": _vm.uploadingProgress,
                        },
                        on: {
                          changeFileList: _vm.changeFileList,
                          changeUploading: _vm.changeUploading,
                          changeUploadingProgress: _vm.changeUploadingProgress,
                          changeRemoveFiles: _vm.changeRemoveFiles,
                        },
                        model: {
                          value: _vm.form.mp,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "mp", $$v)
                          },
                          expression: "form.mp",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "kyc-upload-card" },
                [
                  _c("div", { staticClass: "kyc-upload-title" }, [
                    _c("span", { staticStyle: { color: "#f56c6c" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v(
                      _vm._s(_vm.$t("kyc.company_document_license_permit"))
                    ),
                  ]),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item-no-style",
                      attrs: { prop: "lp" },
                    },
                    [
                      _c("UpdateFile", {
                        ref: "lp",
                        attrs: {
                          type: "lp",
                          "file-list": _vm.fileList,
                          uploading: _vm.uploading,
                          "remove-files": _vm.removeFiles,
                          "uploading-progress": _vm.uploadingProgress,
                        },
                        on: {
                          changeFileList: _vm.changeFileList,
                          changeUploading: _vm.changeUploading,
                          changeUploadingProgress: _vm.changeUploadingProgress,
                          changeRemoveFiles: _vm.changeRemoveFiles,
                        },
                        model: {
                          value: _vm.form.lp,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "lp", $$v)
                          },
                          expression: "form.lp",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.form.type_of_business === 2 ||
              (_vm.kycData &&
                _vm.kycData.company_basic_info &&
                _vm.kycData.company_basic_info.type_of_business === 2)
                ? _c(
                    "div",
                    { staticClass: "kyc-upload-card" },
                    [
                      _c("div", { staticClass: "kyc-upload-title" }, [
                        _c("span", { staticStyle: { color: "#f56c6c" } }, [
                          _vm._v("*"),
                        ]),
                        _vm._v(
                          _vm._s(_vm.$t("kyc.company_document_annual_report"))
                        ),
                      ]),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "form-item-no-style",
                          attrs: { prop: "ar" },
                        },
                        [
                          _c("UpdateFile", {
                            ref: "ar",
                            attrs: {
                              type: "ar",
                              "file-list": _vm.fileList,
                              uploading: _vm.uploading,
                              "remove-files": _vm.removeFiles,
                              "uploading-progress": _vm.uploadingProgress,
                            },
                            on: {
                              changeFileList: _vm.changeFileList,
                              changeUploading: _vm.changeUploading,
                              changeUploadingProgress:
                                _vm.changeUploadingProgress,
                              changeRemoveFiles: _vm.changeRemoveFiles,
                            },
                            model: {
                              value: _vm.form.ar,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "ar", $$v)
                              },
                              expression: "form.ar",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "kyc-upload-card" },
                [
                  _c("div", { staticClass: "kyc-upload-title" }, [
                    _vm._v(
                      _vm._s(_vm.$t("kyc.company_document_other_documents"))
                    ),
                  ]),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item-no-style",
                      attrs: { prop: "rest_file" },
                    },
                    [
                      _c("UpdateFile", {
                        ref: "rest_file",
                        attrs: {
                          type: "rest_file",
                          "file-list": _vm.fileList,
                          uploading: _vm.uploading,
                          "remove-files": _vm.removeFiles,
                          "uploading-progress": _vm.uploadingProgress,
                        },
                        on: {
                          changeFileList: _vm.changeFileList,
                          changeUploading: _vm.changeUploading,
                          changeUploadingProgress: _vm.changeUploadingProgress,
                          changeRemoveFiles: _vm.changeRemoveFiles,
                        },
                        model: {
                          value: _vm.form.rest_file,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "rest_file", $$v)
                          },
                          expression: "form.rest_file",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]
        ),
        _c(
          "div",
          { staticClass: "kyc-footer" },
          [
            _c(
              "el-button",
              {
                staticClass: "kyc-draft-btn",
                attrs: { disabled: _vm.isSubmitting },
                on: { click: _vm.handleSave },
              },
              [_vm._v(_vm._s(_vm.$t("kyc.save_as_draft")))]
            ),
            _c(
              "el-button",
              {
                staticClass: "kyc-next-btn",
                attrs: { type: "primary", disabled: _vm.isSubmitting },
                on: { click: _vm.handleNext },
              },
              [_vm._v(_vm._s(_vm.$t("kyc.next_step")))]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }